import Vue from 'vue';
import VueRouter from 'vue-router';

import BioTestingQuizDashboard from '../views/BioTestingQuizDashboard.vue';
import BioTestingCreateQuiz from '../views/BioTestingCreateQuiz.vue';
import BioTestingTakeQuiz from '../views/BioTestingTakeQuiz.vue';
import BioTestingQuizResults from '../views/BioTestingQuizResults.vue';

import BusinessTeams from '../views/BusinessTeams.vue';

import CardsAdmin from '../views/CardsAdmin.vue';
import Challenges from '../views/Challenges.vue';
import ChallengesArchive from '../views/ChallengesArchive.vue';
import ChallengeMembers from '../views/ChallengeMembers.vue';
import ChallengeEmail from '../views/ChallengeEmail.vue';
import Charts from '../views/ChartsData.vue';
import Courses from '../views/Courses.vue';
import CoursesAdmin from '../views/CoursesAdmin.vue';
import CoursesSectionAdmin from '../views/CoursesSectionAdmin.vue';
import Dashboard from '../views/Dashboard.vue';
import Dreams from '../views/Dreams.vue';
import EmailMembers from '../views/EmailMembers.vue';
import Feelings from '../views/Feelings.vue';
import Login from '../views/Login.vue';
import Members from '../views/Members.vue';
import MyConnections from '../views/MyConnections.vue';
import ProfileOverviewDashboard from '../views/ProfileOverviewDashboard.vue';
import Profile from '../views/Profile.vue';
import ProfileReport from '../views/ProfileReport.vue';
import Register from '../views/Register.vue';
import ReportsOverview from '../views/ReportsOverview.vue';
import ResetPassword from '../views/ResetPassword.vue';
import Sandpit from '../views/Sandpit.vue';
import SubscriptionOverview from '../views/SubscriptionOverview.vue';
import Teams from '../views/Teams.vue';
import Healing from "../views/Healing.vue";
import Coaches from '../views/coaches_dashboard.vue';

import Error404 from '../views/Error404.vue';
import Chatbox from "@/views/Chatbox";

Vue.use(VueRouter);

const routes = [
	{
		path: '/auth/reset_password/:hash',
		name: 'reset_password',
		component: ResetPassword,
		meta: {
			title: 'Reset Password',
		},
	},

	{
		path: '/cards_admin',
		name: 'cards_admin',
		component: CardsAdmin,
		meta: {
			title: 'Cards',
			min_level: 'admin',
		},
	},

	{
		path: '/',
		alias: '/dashboard',
		name: 'home',
		component: Dashboard,
		meta: {
			title: 'My Dashboard',
			min_level: 'member',
			showShortcuts: true,
		},
	},
	{
		path: '/dashboard/:user_id',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			title: 'Member Dashboard',
			min_level: 'member',
		},
	},

	{
		path: '/databaseDL/:token',
		name: 'databaseDL',
		meta: {
			title: 'DBDL',
			min_level: 'admin',
		},
		beforeEnter(uri) {
			console.log(uri.params.token);
			window.open('https://api.iamconnected.com/databaseDL?token=' + uri.params.token, '_blank');
		},
	},
	{
		path: '/charts/:metrics/:user_id',
		name: 'charts',
		component: Charts,
		meta: {
			title: 'Chart Data',
			min_level: 'member',
		},
	},

	/*
  {
    path: "/category/:category",
    name: "dashboard",
    component: Dashboard,
    meta: {
      title: 'Category Dashboard',
      dash_type: 'category',
    },
  },
  */
	{
		path: '/bioTesting/quizzes_submitted',
		name: 'BioTestingQuizDashboard',
		component: BioTestingQuizDashboard,
		meta: {
			title: 'BioTesting - Submitted Quizzes',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/create',
		name: 'bioTestingCreateQuiz',
		component: BioTestingCreateQuiz,
		meta: {
			title: 'BioTesting Create/Edit Quiz',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/edit',
		name: 'bioTestingCreateQuizList',
		component: BioTestingCreateQuiz,
		meta: {
			title: 'BioTesting Quizzes',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/edit/:quiz_id',
		name: 'bioTestingCreateQuizEdit',
		component: BioTestingCreateQuiz,
		meta: {
			title: 'BioTesting Edit Quiz',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quiz_result/:result_id',
		name: 'BioTestingQuizResults',
		component: BioTestingQuizResults,
		meta: {
			title: 'BioTesting Quiz Results',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/takeQuiz/:quiz_id',
		name: 'BioTestingTakeQuiz',
		component: BioTestingTakeQuiz,
		meta: {
			title: 'BioTesting Take Quiz',
			min_level: 'member',
		},
	},
	/*
	{
		path: '/bioTesting_dashboard',
		name: 'bioTesting_dashboard',
		component: Dashboard,
		meta: {
			title: 'BioTesting Dashboard',
			category: 'bioTesting',
			dash_type: 'category',
		},
	},
	{
		path: '/bioTesting_Dashboard',
		name: 'bioTesting_Dashboard',
		component: bioTesting_Dashboard,
		meta: {
			title: 'BioTesting Dashboard',
			category: 'bioTesting',
			dash_type: 'category',
			
		},
	},
	*/
	{
		path: '/course/:id',
		name: 'course_entry',
		component: Courses,
		meta: {
			title: 'Course Entry',
			min_level: 'member',
		},
	},
	{
		path: '/courses',
		name: 'courses_dashboard',
		component: Courses,
		meta: {
			title: 'Courses Dashboard',
			min_level: 'member',
		},
	},
	{
		path: '/courses_admin',
		name: 'courses_admin',
		component: CoursesAdmin,
		meta: {
			title: 'Courses Admin',
			min_level: 'admin',
		},
	},
	{
		path: '/course_sections/:id',
		name: 'course_sections',
		component: CoursesSectionAdmin,
		meta: {
			title: 'Course Section Admin',
			min_level: 'admin',
		},
	},
	/*
	{
		path: '/dreams_dashboard',
		name: 'dreams_dashboard',
		component: Dashboard,
		meta: {
			title: 'Dreams Dashboard',
			category: 'dreams',
			dash_type: 'category',
		},
	},
	*/
	{
		path: '/dreams_log/:user_id',
		name: 'dreams_log',
		component: Dreams,
		meta: {
			title: 'Dreams Log',
			min_level: 'member',
		},
	},
	{
		path: '/feelings_log/:user_id',
		name: 'feelings_log',
		component: Feelings,
		meta: {
			title: 'Feelings Log',
			min_level: 'member',
		},
	},
	/*
	{
		path: '/general_discussion_dashboard',
		name: 'general_discussion_dashboard',
		component: Dashboard,
		meta: {
			title: 'General Discussion Dashboard',
			category: 'general_discussion',
			dash_type: 'category',
		},
	},
	*/
	{
		path: '/meditation_dashboard',
		name: 'meditation_dashboard',
		component: Dashboard,
		meta: {
			title: 'Meditation Dashboard',
			category: 'meditation',
			dash_type: 'category',
			showShortcuts: true,
		},
	},
	/*
	{
		path: '/nutrition_dashboard',
		name: 'nutrition_dashboard',
		component: Dashboard,
		meta: {
			title: 'Nutrition Dashboard',
			category: 'nutrition',
			dash_type: 'category',
		},
	},
	*/
	{
		path:'/coaches_dashboard',
		name:'Coaches',
		component: Coaches,
		meta:{
			title:'Coaches',
			category:'Coaches',
			dash_type:'Coaches',
		}

	},
	{
		path: '/healing_dashboard',
		name: 'headling_dashboard',
		component: Healing,
		meta: {
			title: 'Healing Dashboard',
			category: 'healing',
			dash_type: 'category',
		},
	},
	{
		path: '/psychedelics_dashboard',
		name: 'psychedelics_dashboard',
		component: Dashboard,
		meta: {
			title: 'Psychedelics Dashboard',
			category: 'psychedelics',
			dash_type: 'category',
		},
	},
	{
		path: '/sleep_dashboard',
		name: 'sleep_dashboard',
		component: Dashboard,
		meta: {
			title: 'Sleep Dashboard',
			category: 'sleep',
			dash_type: 'category',
		},
	},
	{
		path: '/payments/manage_billing',
		name: 'manage_billing',
	},
	{
		path: '/payments/subscriptions/:page_type',
		name: 'subscriptions_action',
		component: SubscriptionOverview,
		meta: {
			title: 'Subscriptions',
		},
	},
	{
		path: '/payments/subscriptions',
		name: 'subscriptions',
		component: SubscriptionOverview,
		meta: {
			title: 'Subscriptions',
		},
	},

	{
		path: '/profile_overview_dashboard/:user_id',
		name: 'profile_overview',
		component: ProfileOverviewDashboard,
		meta: {
			title: 'Member - Profile Overview',
		},
	},

	{
		path: '/profile_report/:user_id',
		name: 'profile_report',
		component: ProfileReport,
		meta: {
			min_level: 'member',
			title: 'Profile Reports',
		},
	},

	{
		path: '/register',
		name: 'register',
		component: Register,
		meta: {
			title: 'Register',
		},
	},

	{
		path: '/reports_overview',
		name: 'reports_overview',
		component: ReportsOverview,
		meta: {
			min_level: 'admin',
			title: 'Reports Overview',
		},
	},

	{
		path: '/board_sleep',
		name: 'board_sleep',
		beforeEnter() {
			window.open('https://sleep.iamconnected.com', '_self');
		},
	},
	{
		path: '/board_meditation',
		name: 'board_meditation',
		beforeEnter() {
			window.open('https://meditation.iamconnected.com', '_self');
		},
	},
	{
		path: '/board_meditation/muse',
		name: 'board_meditation_muse',
		beforeEnter() {
			window.open('https://meditation.iamconnected.com/muse', '_self');
		},
	},
	{
		path: '/email_members',
		name: 'email_members',
		component: EmailMembers,
		meta: {
			min_level: 'admin',
			title: 'Email Members',
		},
	},
	{
		path: '/fetch_api_data',
		name: 'fetch_api_data',
		beforeEnter() {
			window.open(process.env.VUE_APP_API_URL + 'fetch_api_data', '_blank');
		},
	},
	{
		path: '/forum',
		name: 'forum',
		beforeEnter() {
			window.open('https://forum.iamconnected.com', '_self');
		},
	},
	{
		path: '/forum/categories/:slug',
		name: 'forum_categories',
		beforeEnter(vars) {
			window.open('https://forum.iamconnected.com/categories/' + vars.params.slug, '_self');
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login',
		},
	},
	{
		path: '/login/forgot',
		name: 'login_forgot',
		component: Login,
		meta: {
			title: 'Login',
		},
	},
	{
		path: '/business_teams',
		name: 'business_teams',
		component: BusinessTeams,
		meta: {
			min_level: 'admin',
			title: 'Business Teams',
		},
	},
	{
		path: '/members',
		name: 'members',
		component: Members,
		meta: {
			min_level: 'admin',
			title: 'Members',
		},
	},
	/*
	{
		path: '/teams',
		name: 'teams',
		component: Teams,
		meta: {
			min_level: 'member',
			title: 'My Team Members',
		},
	},
	*/
	{
		path: '/connections',
		name: 'connections',
		component: MyConnections,
		meta: {
			min_level: 'member',
			title: 'My Connections',
		},
	},
	{
		path: '/challenges',
		name: 'challenges',
		component: Challenges,
		meta: {
			min_level: 'member',
			title: 'Challenges',
		},
	},
	{
		path: '/challenges/archive',
		name: 'ChallengesArchive',
		component: ChallengesArchive,
		meta: {
			min_level: 'admin',
			title: 'Challenges Archive',
		},
	},
	{
		path: '/challenges/:challenge_id?',
		name: 'ChallengeMembers',
		component: ChallengeMembers,
		meta: {
			min_level: 'member',
			title: 'Challenge Members',
		},
	},
	{
		path: '/challenges/:challenge_id?/email',
		name: 'ChallengeEmail',
		component: ChallengeEmail,
		meta: {
			min_level: 'admin',
			title: 'Challenge Email',
		},
	},
	{
		path: '/teams/:team_id',
		name: 'team',
		component: Teams,
		meta: {
			min_level: 'coach',
			title: 'Team Members',
		},
	},
	{
		path: '/profile',
		name: 'profile',
		component: Profile,
		meta: {
			min_level: 'member',
			title: 'My Profile',
		},
	},
	{
		path: '/chatbox/:recipientId?',
		name: 'chatbox',
		component: Chatbox,
		meta: {
			title: 'Chatbox',
		},
	},
	{
		path: '/sample_data',
		name: 'sample_data',
		component: Dashboard,
		meta: {
			min_level: 'member',
			title: "Troy's Data",
		},
	},
	{
		path: '/sandpit',
		name: 'sandpit',
		component: Sandpit,
		meta: {
			min_level: 'admin',
			title: 'Sandpit',
		},
	},

	{
		path: '*',
		name: '404',
		component: Error404,
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
});

export default router;
